import { render, staticRenderFns } from "./EditContentRepeater.vue?vue&type=template&id=17c38b67&scoped=true"
import script from "./EditContentRepeater.vue?vue&type=script&lang=js"
export * from "./EditContentRepeater.vue?vue&type=script&lang=js"
import style0 from "./EditContentRepeater.vue?vue&type=style&index=0&id=17c38b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c38b67",
  null
  
)

export default component.exports